import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlAdiantamentosSuprimentos = '/service/contabilidade/transparencia/adiantametos/'

class DetalhesAdiantamentosSuprimentosService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            sequencial: filtro.sequencial,
            administracao: filtro.administracao,
        }
        return this.conex.post(urlAdiantamentosSuprimentos + 'detalhesAdiantamentosSuprimentos/', JSON.stringify(data))
    }

    consultarFornecedores(filtro) {
        let data = {
            exercicioAdiantamento: filtro.exercicioAdiantamento,
            numeroAdiantamento: filtro.numeroAdiantamento,
            administracao: filtro.administracao,
        }
        return this.conex.post(urlAdiantamentosSuprimentos + 'detalhesAdiantamentosSuprimentosFornecedores/', JSON.stringify(data))
    }
}

export default DetalhesAdiantamentosSuprimentosService
